module.exports = __webpack_public_path__ + "static/pokoj-nr3-photo02-miniaturka-071f7fa301adac81632c1fa9f13c7a43.jpg";